import { inject, Injectable } from '@angular/core';
import { API_ENDPOINTS } from '../models/enums/endpoints.enum';
import { Observable, throwError } from 'rxjs';
import { ApiProviderService } from './api-provider.service';
import { TransportOrderModification } from '../models/transport-order-modification.model';
import { mapAsBody } from '../app/shared/util/request-util';
import { HttpErrorResponse } from '@angular/common/http';
import { catchError } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class TransportOrderModificationService {
  readonly #apiProvider = inject(ApiProviderService);

  protected resourceUrl = API_ENDPOINTS.TRANSPORT_ORDER_MODIFICATIONS;
  protected basketOrderUrl = API_ENDPOINTS.BASKET_ORDER;

  public saveAll(basketOrderId: number, transportOrderModifications: TransportOrderModification[]): Observable<any> {
    return this.#apiProvider.post(`${this.resourceUrl}${this.basketOrderUrl}/${basketOrderId}`, transportOrderModifications).pipe(
      mapAsBody,
      catchError((error: HttpErrorResponse) => {
        // Retourne uniquement le contenu de l'erreur
        return throwError(error.error);
      })
    );
  }
}
